<template>
  <!-- Panel sortowania: etykieta pola + lista rozwijana z kierunkiem -->
  <div class="sort-by ds-panel">
    <div class="ds-panel__head">
      <h3 class="ds-panel__title">{{ t('sorting').toUpperCase() }}</h3>
    </div>

    <div class="ds-panel__body">
      <!-- Komponent select-filter:
           - name: etykieta pola (kierunek sortowania)
           - fieldName: klucz w store.filters
           - type: identyfikator typu filtrowania
           - store: przekazanie instancji store z filtrami
           - selected: domyślnie 'desc' (malejąco)
      -->
      <select-filter
        :name="t('direction').toUpperCase()"
        fieldName="orderDirection"
        type="direction"
        :store="filtersStore"
        selected="desc"
      />
    </div>
  </div>
</template>

<script>
// Import store Pinia dla bieżących filtrów
import { useCurrentFiltersStore } from "@/stores/currentFilters";
// Import komponentu select-filter używanego do wyboru opcji
import SelectFilter from "../filters/SelectFilter.vue";

export default {
  name: "SortBy",       // Nazwa komponentu
  components: { SelectFilter }, // Rejestracja komponentu potomnego
  setup() {
    // Inicjalizacja store'u z aktualnymi filtrami
    const filtersStore = useCurrentFiltersStore();
    // Zwrócenie instancji store do użycia w szablonie
    return { filtersStore };
  },
};
</script>

<style scoped>
.sort-by {
  min-width: 0;
}
</style>
